import { useEffect } from "react";
import { useSelector } from "react-redux";
import Accordion from "react-bootstrap/esm/Accordion";
import Card from "react-bootstrap/esm/Card";
import { useAppDispatch, RootState } from "../../../redux/store";
import { retrieveAccordionSchedule } from "../../../redux/slice/accordion-schedule-slice";

const AccordionSchedule = (props: { path: string }) => {
  const dispatch = useAppDispatch();
  const { AccordionScheduleData } = useSelector((state: RootState) => state.AccordionSchedule);

  useEffect(() => {
    dispatch(retrieveAccordionSchedule(`${props.path}%2FSchedule-Items`));
  }, [dispatch])

  return (
    <>
      {AccordionScheduleData[0]?.data.length > 0 &&
        <div className="container">
          <Accordion flush className='convergence'>
            {AccordionScheduleData[0]?.data?.map((item, index) => {
              return <Card className='m-0'>
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Card.Header>
                    <Accordion.Header className="btn btn-block heading">
                      <span dangerouslySetInnerHTML={{ __html: item.name }}></span>
                      <i aria-hidden="true" className="fa fa-angle-double-down" id="fa-angle-arrow"></i>
                    </Accordion.Header>
                  </Card.Header>
                  <Accordion.Body dangerouslySetInnerHTML={{ __html: item.description }}></Accordion.Body>
                </Accordion.Item>
              </Card>
            })}
          </Accordion>
          <div>&nbsp;</div>
        </div>}
    </>
  )
};

export default AccordionSchedule;